import React from "react";
import { Fragment } from "react";

export default function PaymentMethodHeader() {
  return (
    <Fragment>
        <h2>Payment Method</h2>
    </Fragment>
  );
}
